import axios from "axios";

export default class AdfLostPassword
{

    constructor ( nav )
    {
        this.nav = nav;
        this.createClosure();
        this.bindEvents();
    }

    createClosure ()
    {
        this.fctSend           = this.submit.bind( this );
        this.fctShowConnection = this.showConnection.bind( this );
    }

    bindEvents ()
    {
        this.txtPassword   = document.querySelector( "#password" );
        this.txtConfirm    = document.querySelector( "#password_confirmation" );
        this.allInputs     = [ this.txtPassword ].concat( this.txtConfirm );
        this.hiddenToken   = document.querySelector( "#token" );
        this.btnSend       = document.querySelector( "#btn_send" );
        this.btnConnection = document.querySelector( "#btn_connexion" );
        this.divForm       = document.querySelector( "div#form" );
        this.divMessage    = document.querySelector( "div#message_redirect" );

        this.btnSend.addEventListener( "click", this.fctSend )
        this.btnConnection.addEventListener( "click", this.fctShowConnection )
    }

    clearErrors ()
    {
        let arrErrors = Array.from( document.querySelectorAll( ".text-error" ) );

        for ( let i = 0; i < arrErrors.length; i++ )
        {
            let error = arrErrors[ i ];
            error.classList.add( "d-none" );
        }

        this.allInputs.forEach( ( el ) =>
        {
            el.removeAttribute( 'aria-invalid' );
            el.removeAttribute( 'aria-errormessage' );
        } )
    }

    async submit ( e )
    {
        e.preventDefault();

        let payload = {
            form                  : "recuperation-du-mot-de-passe",
            password              : this.txtPassword.value,
            password_confirmation : this.txtConfirm.value,
            token                 : this.hiddenToken.value,
        };

        this.clearErrors();

        let response = await axios.post( "/endpoints/form/validate", payload );

        let data = response.data;

        if ( data.success )
        {
            let response = await axios.post( "/endpoints/user/change-password", payload );

            if ( response.data.success )
            {
                this.divForm.classList.add( "d-none" );
                this.divMessage.classList.remove( "d-none" );

                setTimeout( () => window.location.href = "/", 5000 )

            } else
            {
                let spanError = document.querySelector( "#error_password" );

                spanError.textContent = "Impossible de changer le mot de passe."
                spanError.classList.remove( "d-none" );
            }
            return;
        }

        let errors = data.errors;

        let firstErrorInput;
        for ( let strError in errors )
        {
            let error = errors[ strError ];

            let targetInput = document.querySelector( "#" + strError );
            let spanError   = document.querySelector( "#error_" + strError );

            if ( !firstErrorInput )
            {
                firstErrorInput = targetInput;
            }

            spanError.textContent = error.join( " " );
            spanError.classList.remove( "d-none" );

            targetInput.setAttribute( 'aria-invalid', true );
            targetInput.setAttribute( 'aria-errormessage', "error_" + strError );

        }

        if ( typeof firstErrorInput !== 'undefined' )
        {
/*console.log(( 'firstErrorInput', firstErrorInput ))*/;
            // firstErrorInput.focus();
        }

    }

    showConnection ()
    {
        this.nav.showUserModal();
    }
}
